module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"no_result":"Not found.","no_more_data":"No more data.","errMsg":"Could not get the data. <br>Your network condition may be bad. <br>Please check your network condition and try again."}}')
  delete Component.options._Ctor
}
